var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 40 } },
    _vm._l(_vm.pair, function(info, j) {
      return _c(
        "el-col",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingProfile,
              expression: "loadingProfile"
            }
          ],
          key: j,
          attrs: { span: 12 }
        },
        [
          !_vm.loadingProfile
            ? _c("div", { staticClass: "load-up card-panel right-height" }, [
                _c("div", { staticClass: "card-layout" }, [
                  _c(
                    "div",
                    { staticClass: "card-panel-description" },
                    [
                      _c("div", { staticClass: "card-panel-text" }, [
                        _vm._v(_vm._s(info.top.label))
                      ]),
                      _vm._v(" "),
                      _c("count-to", {
                        staticClass: "card-panel-num",
                        attrs: {
                          "start-val": 0,
                          "end-val": info.top.value,
                          duration: 2600,
                          decimals: info.decimal ? info.numberOfDecimal : 0
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card-panel-icon-wrapper",
                      style: "color: " + info.color
                    },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class": info.icon,
                          "class-name": "card-panel-icon"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-lower" }, [
                  _c("div", { staticClass: "card-lower-value" }, [
                    _c(
                      "div",
                      { style: "color: " + info.color },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": info.bottom.value,
                            duration: 2600,
                            decimals: info.decimal ? info.numberOfDecimal : 0
                          }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(info.unit) +
                            "\n            "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-lower-description" }, [
                      _vm._v(_vm._s(info.bottom.label))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "indicator",
                      style: "background: " + info.color
                    },
                    [_vm._v(_vm._s(info.text))]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }